import MainPage from '../pages/Main/MainPage';
import PastPage from '../pages/PastPage/PastPage';
import ArchPage from '../pages/ArchPage/ArchPage';
import ResidentsPage from '../components/ResidentsPage/ResidentsPage';
import PopupPage from '../pages/PopupPage/PopupPage';
import FuturePage from '../pages/FuturePage';
import ContactsPage from '../components/ContactsPage/ContactsPage';
import EventPage from "../pages/EventPage/EventPage";

const routes = [
	{
		path: '/',
		component: MainPage,
		exact: true,
	},
	{
		path: '/past',
		component: PastPage,
	},
	{
		path: '/arch',
		component: ArchPage,
	},
	{
		path: '/residents',
		component: ResidentsPage,
	},
	{
		path: '/popup',
		component: PopupPage,
	},
	{
		path: '/future',
		component: FuturePage,
	},
	{
		path: '/contacts',
		component: ContactsPage,
	},
	{
		path: '/event/:id',
		component: EventPage,
	}
];

export default routes;